// extracted by mini-css-extract-plugin
export default {"card":"ArticleCard_card__h4wBn","content":"ArticleCard_content__K3yfA","active":"ArticleCard_active__WSPTv","illustration":"ArticleCard_illustration__8Vx1J"};